const homePageData = {
  title: "وذكر",
  subTitle: "طيب لسانك بذكر الله",
  brand: "الرئيسية",
};

export default homePageData;
